import AcceptedAddress from '../../cards/accepted-address';
import AcceptedOffer from '../../cards/accepted-offer';
import CloseDate from '../../cards/close-date';
import { OutOfStateContactInfo } from '../../cards/contact-info-short/out-of-state';
import EarlyKickOut from '../../cards/early-kick-out';
import { BorrowerFirstTimeBuyer } from '../../cards/first-time-buyer';
import Occupancy from '../../cards/occupancy';
import PurchasePrice from '../../cards/purchase-price';
import { Branch, Card, End } from '../../components/deck';
import { DownPaymentBranch } from './down-payment';
import { PropertyTypeBranch } from './property-type';
import { permittedStates, PurchaseStateVerification } from './state-verification';

export default (resume) =>
  PurchaseStateVerification(
    Card(
      AcceptedOffer,
      Branch(
        {
          AcceptedAddress: Card(AcceptedAddress, Card(CloseDate)),
          NotEligible: Card(OutOfStateContactInfo, Card(EarlyKickOut, End()))
        },
        ({ model }) => {
          const veteranStatus = model.getIn(['borrower', 'vaQualification']);
          const hasAcceptedOffer = model.getIn(['loan', 'acceptedOffer']);
          const isVeteranEligible = veteranStatus && veteranStatus !== 'Ineligible';

          const inState =
            permittedStates.includes(model.getIn(['loan', 'loanState'])) ||
            model.getIn(['loan', 'advisor']);

          return isVeteranEligible && !hasAcceptedOffer && !inState
            ? 'NotEligible'
            : hasAcceptedOffer && 'AcceptedAddress';
        },
        PropertyTypeBranch(
          Card(
            Occupancy,
            Card(PurchasePrice, DownPaymentBranch(Card(BorrowerFirstTimeBuyer, resume)))
          )
        )
      )
    )
  );



// WEBPACK FOOTER //
// ./src/decks/branches/purchase.js